import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Grid, Cell } from "react-md";
import { EmployeeDetails } from "components/User";
import EmployeeCourses from "components/Employee/EmployeeCourses";
import { userHasRight } from "selectors/rights";
import { EMPLOYEE_COURSE_VIEW, MANAGEMENT_CALENDAR_EDIT } from "typeConstants/rights";
import MCard from "components/Shared/MCard.tsx";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";
import LinkedUsersCard from "components/User/LinkedUser.tsx";

const EmployeeProfile = props => {
  const cellWidth = props.verticalDisplay ? 12 : 4;

  return (
    <Grid className="md-grid-cards">
      <Cell size={cellWidth}>
        <EmployeeDetails employeeId={props.employeeId} />
      </Cell>
      {props.canViewEmployeeCourses &&
      <Cell size={cellWidth}>
        <EmployeeCourses employeeId={props.employeeId} />
      </Cell>}
      <Cell size={cellWidth}>
        <MCard
        title="Employee Calendar"
        fields={[{ 
          key: "calendar", 
          control: (
            <EmployeeCalendar 
              employeeId={props.employeeId}
              readOnly={props.canEditEmployeeCalendar ? false: true}
              allowManagementEdit={props.canEditEmployeeCalendar}
            />)
          }]}
        />
      </Cell>
      <Cell size={cellWidth}>
        <LinkedUsersCard
          employeeInternetUserId={props.internetUserId}
          employeeId={props.employeeId}
        />
      </Cell>
    </Grid>);
};

EmployeeProfile.propTypes = {
  employeeId: PropTypes.number,
  verticalDisplay: PropTypes.bool,
  canViewEmployeeCourses: PropTypes.bool.isRequired,
  canEditEmployeeCalendar: PropTypes.bool.isRequired,
  internetUserId: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    canViewEmployeeCourses: userHasRight(EMPLOYEE_COURSE_VIEW)(state),
    canEditEmployeeCalendar: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
  };
};

export default connect(mapStateToProps)(EmployeeProfile);
